import type { LocalizationContext } from "../../lib/api/localization";

export type AiFillEmptyField = {
  context: LocalizationContext;
  entryId: string;
  key: string;
  sourceText: string;
};

export type AiFillTranslation = {
  key: string;
  translatedText: string;
};

/**
 * Map one context batch's AI translations onto its draft entry IDs by key.
 * `emptyFields` must all share the same `context` as the `aiFillTranslations`
 * call that produced `translations` (the endpoint is scoped to one context
 * per call and its response carries no context field).
 */
export function matchAiFillToEntries(
  emptyFields: AiFillEmptyField[],
  translations: AiFillTranslation[],
): Map<string, string> {
  const updates = new Map<string, string>();

  const byKey = new Map<string, AiFillEmptyField[]>();
  for (const field of emptyFields) {
    const list = byKey.get(field.key) ?? [];
    list.push(field);
    byKey.set(field.key, list);
  }

  for (const row of translations) {
    const text = row.translatedText.trim();
    if (!text) continue;

    const fields = byKey.get(row.key);
    if (!fields?.length) continue;
    for (const field of fields) {
      if (!updates.has(field.entryId)) {
        updates.set(field.entryId, text);
      }
    }
  }

  return updates;
}
